<mbs-card
  *ngIf="params?.showItem"
  class="mb-3"
  [customClasses]="'bg-light border-radius-xl-important h-auto'"
  [hasPadding]="false"
  [innerBordered]="false"
  [size]="MbsSize.xs">
  <mbs-card-group class="w-100 p-3">
    <div class="d-flex align-items-center justify-content-between">
      <span class="fw-bold">{{ 'wizards:excludeText' | i18next }}</span>
      <mbs-switcher
        [ngModelOptions]="{ standalone: true }"
        [(ngModel)]="enabledFields"
        (afterUpdate)="enabledFieldsChangeHandler()"></mbs-switcher>
    </div>
  </mbs-card-group>
  <mbs-card-group
    class="w-100 p-3"
    [ngbCollapse]="!enabledFields">
    <mbs-group-button
      *ngIf="!params?.isOffline"
      class="mb-3">
      <mbs-button
        [active]="viewMode === viewTabState.tree"
        (click)="showTreeChangeHandler(viewTabState.tree)"
        >{{ 'wizards:treeView' | i18next }}</mbs-button
      >
      <mbs-button
        [active]="viewMode === viewTabState.manually"
        (click)="showTreeChangeHandler(viewTabState.manually)"
        >{{ 'wizards:manuallyView' | i18next }}</mbs-button
      >
    </mbs-group-button>
    <mbs-card
      *ngIf="viewMode === viewTabState.tree && !params?.isOffline"
      class="position-relative"
      [size]="MbsSize.xs"
      [staticHeight]="200">
      <div class="p-3">
        <mbs-loader
          *ngIf="loading"
          [size]="'small'"></mbs-loader>
        <mbs-tree
          *ngIf="treeData?.length && !loading"
          #treeComponent
          mode="file"
          [childrenManualControl]="true"
          [classesForRoot]="'mbs-files-folders-tree'"
          [data]="treeData"
          [disableChildren]="false"
          [disableIfLoadingSubtree]="true"
          [dontSelectChildren]="false"
          [getItems]="getSubtree.bind(this)"
          [height]="'170px'"
          [itemsCanBeHidden]="true"
          [lazy]="true"
          [loadMore]="getSubtree.bind(this)"
          [offCheckAndIndeterminate]="true"
          (mbsChange)="changeTreeHandler($event)">
          <ng-template
            let-item
            treeElement>
            <span class="form-row align-items-center flex-nowrap _hover-parent">
              <span class="col-auto">
                <img
                  alt="Tree icon {{ item.id }}"
                  class="mbs-files-folders-tree_img-main"
                  [src]="item.icon" />
              </span>
              <span class="col overflow-hidden">
                <mbs-text-ellipsis [tooltip]="item.label">{{ item.label }}</mbs-text-ellipsis>
              </span>
              <span
                *ngIf="item.showNTFSAlert"
                class="ico ico-OverdueSettings tooltip-btn text-orange ml-1 mr-2"
                container="body"
                placement="top"
                [ngbTooltip]="'wizards:selected_virtual_disks_non_ntfs_disk' | i18next"></span>
            </span>
          </ng-template>
        </mbs-tree>
      </div>
    </mbs-card>

    <div
      *ngIf="viewMode === viewTabState.manually || params?.isOffline"
      class="mbs-files-folders-list-block"
      [formGroup]="foldersForm">
      <mbs-files-folders-list
        #fileFoldersListComponent
        formControlName="filesFoldersData"
        [isUnix]="params?.isUnix"
        [needShowEnabled]="false"
        [placeholderForEnabledFields]="(params?.isUnix ? 'wizards:enterExcludeUnixText' : 'wizards:enterExcludeWinText') | i18next"
        [showItem]="params?.showItem"></mbs-files-folders-list>
    </div>
  </mbs-card-group>
</mbs-card>
